
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 26 26"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#50585B","stroke-width":"1.1","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M1 13C1 6.373 6.373 1 13 1s12 5.373 12 12-5.373 12-12 12S1 19.627 1 13z"}}),_c('path',{attrs:{"d":"M21.87 4.906s-.522 2.864-2.61 3.908c-2.086-.522-4.173 1.043-3.652 1.043.522 0 1.044 2.087 1.044 2.087.522.522 1.565 0 1.565 0 1.305 1.304-2.087 3.652-2.087 4.174 0 .522 1.305.783.522 1.565-.783.783-1.565 1.044-1.565 1.044 0 2.608-2.609 2.608-3.13 2.608-.522 0-1.566-2.087-1.566-2.608 0-.522.522-1.044.522-1.566 0-.521-1.044-1.565-1.044-1.565 0-2.087-1.565-1.565-3.13-1.565s-1.565-2.087-1.565-2.087 0-3.652 2.608-4.174c2.61-.522 2.61.522 2.61.522 1.043 1.043 3.13 0 4.173 0 0 0 .522-3.652-.522-3.13-1.043.521-1.978.117-2.087-1.044-.15-1.63 4.553-2.609 4.553-2.609"}})])])
          )
        }
      }
    